import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRouteDep = ({children}) => {
    const token = localStorage.getItem('token');
    const rol = localStorage.getItem('rol');
    if (token !== null && (rol === 'ADMIN'  || rol === 'PRIMER_CONTACTO' || rol === 'AREA' || rol === 'ASESOR' ||  rol === 'PSICOLOGO' || rol === 'LECTURA')) {
        return children
    } else {
        return <Navigate to="/login" replace={true} />
    }

}

export default PrivateRouteDep;